export { PhoneIncoming as default } from './PhoneIncoming';
